import React from 'react';
import styled from '@emotion/styled';

const ErrorContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    text-align: center;
    padding: 0 20px;
    background-color: #f8f9fa;
`;

const ErrorIcon = styled.div`
    font-size: 72px;
    color: #dc3545;
    margin-bottom: 20px;
`;

const ErrorTitle = styled.h1`
    font-size: 24px;
    color: #343a40;
    margin-bottom: 16px;
`;

const ErrorMessage = styled.p`
    font-size: 16px;
    color: #6c757d;
    margin-bottom: 24px;
    max-width: 500px;
`;

const ContactInfo = styled.div`
    font-size: 14px;
    color: #495057;
    padding: 16px;
    border-radius: 8px;
    background-color: #e9ecef;
`;

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // You can log the error to an error reporting service
        console.error('Error caught by ErrorBoundary:', error, errorInfo);
        this.setState({ error, errorInfo });
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <ErrorContainer>
                    <ErrorIcon>⚠️</ErrorIcon>
                    <ErrorTitle>Oops! Something went wrong</ErrorTitle>
                    <ErrorMessage>
                        We're sorry, but we encountered an unexpected error. Our
                        team has been notified and is working to fix the issue.
                    </ErrorMessage>
                    <ContactInfo>
                        Please try again later or contact support at{' '}
                        <strong>support@avanser.com</strong> if the problem
                        persists.
                    </ContactInfo>
                </ErrorContainer>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
